/**
 * /settings/supervision — SPEC-12 external guard, the supervision screen.
 *
 * Gated on VITE_EXTERNAL_GUARD, which is baked at UI build time and defaults to
 * false. With the flag off the route redirects to Settings rather than mounting
 * an empty shell: the tab is not in the nav either, so a direct hit on the URL
 * is the only way to arrive, and landing on a blank page would read as a broken
 * page rather than as a feature that is not on.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

import { env } from '../../../env';

export const Route = createFileRoute('/_authenticated/settings/supervision')({
  beforeLoad: () => {
    if (!env.VITE_EXTERNAL_GUARD) {
      throw redirect({ to: '/settings/profile', replace: true });
    }
  },
});
